import { calculateCartSubtotal, calculateCodeDiscount, calculateTotalPrice } from '../../helpers/priceHelpers';

const getPriceSummaryValues = (
  pressRelease,
  pressReleaseMetadata,
  sitesList,
  numIncomingSites = 0,
  numIncomingNewsletterAddOns = 0,
  manualPrPrice = null,
) => {
  const currentSite = sitesList.find(
    (site) => site.site_id === pressReleaseMetadata.current_site_pk,
  );
  const selectedSites = sitesList.filter((site) => site.selected);
  const selectedNewsletterAddOns = sitesList
    .filter((site) => site.selected)
    .map((site) => site.topic_newsletter_add_on_options
      .filter((newsletter) => newsletter.selected))
    .flat();
  let numPressReleases = Math.max(selectedSites.length, 1); // at least one PR
  let numNewsletterAddOns = selectedNewsletterAddOns.length;
  let pricePerPressRelease = pressRelease.price_per_press_release
    ?? pressReleaseMetadata.press_release_list_price;

  // Only alter these values when a manualPrPrice has been set, this is
  // only meant for use on the promoteScreen where we're performing
  // synchronous price calculations for GA events.
  if (manualPrPrice !== null) {
    numPressReleases += numIncomingSites;
    numNewsletterAddOns += numIncomingNewsletterAddOns;
    pricePerPressRelease = manualPrPrice;
  }
  const hasMultimediaAddons = pressRelease.multimedia_add_ons.length > 0;

  const subtotal = calculateCartSubtotal(
    numPressReleases,
    numNewsletterAddOns,
    pricePerPressRelease,
    pressReleaseMetadata.topic_newsletter_add_on_price,
    hasMultimediaAddons,
    pressReleaseMetadata.multimedia_add_on_price,
  );

  const totalPrice = calculateTotalPrice(
    numPressReleases,
    numNewsletterAddOns,
    pricePerPressRelease,
    pressReleaseMetadata.topic_newsletter_add_on_price,
    pressRelease.checkout_code,
    hasMultimediaAddons,
    pressReleaseMetadata.multimedia_add_on_price,
  );

  const totalPriceInDollars = totalPrice / 100;

  const codeDiscount = calculateCodeDiscount(
    numPressReleases,
    pricePerPressRelease,
    subtotal,
    pressRelease.checkout_code,
  );

  return {
    currentSite,
    selectedSites,
    selectedNewsletterAddOns,
    numPressReleases,
    numNewsletterAddOns,
    pricePerPressRelease,
    hasMultimediaAddons,
    subtotal,
    totalPrice,
    totalPriceInDollars,
    codeDiscount,
  };
};

export default getPriceSummaryValues;
